export class SpecialBookingModel {
  public startDateTime: string;
  public endDateTime: string;
  public vehicleHashId: string;
  public licenceTag: string;
  public sharedVehicleGroupHashID: string = '';
  public bookingMasterHashId: string;
  public specialBookingType: string;
  public specialBookingRemarks: string;
  public affectedBookingList: string[];
  public adminRemarks: string;
  public comment: string;
  public isConfirmed: boolean = false;
  public isRecurring: boolean = false;
  public recurringPeriod: string = "DAILY";
  public driverHashId: string;
  public driverName: string;
  public organizationHashID: string = '';
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking-special/models/special-booking.model.ts